<template>
  <div class="save">
    <save-page-header title="Period"></save-page-header>
    <el-form
      class="mt-30"
      :label-width="labelWidth + 'px'"
      @submit.prevent.native="submit"
    >
      <translatable-input
        :errors="errors"
        :source.sync="form.names"
        sourceKey="names"
        placeholder="New period"
        title="Name"
        :label-width="labelWidth"
      />
      <div class="align-right">
        <el-col :span="4">
          <el-button
            native-type="submit"
            :loading="savePeriodLoading"
            type="primary"
            plain
            class="plain-primary"
            @click="submit"
          >
            {{ isUpdate ? 'Save Period' : 'Create Period' }}
          </el-button>
        </el-col>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiError, labelWidth } from '@/mixins'
import TranslatableInput from '@/components/Form/TranslatableInput'
import { initMultilingual } from '@/services/helpers'
import SavePageHeader from '@/components/ui/SavePageHeader'

export default {
  components: {
    TranslatableInput,
    SavePageHeader,
  },
  mixins: [apiError('savePeriodError'), labelWidth],
  data: () => ({
    form: {
      names: initMultilingual(),
    },
  }),
  computed: {
    ...mapState('period', ['period', 'savePeriodError', 'savePeriodLoading']),
    isUpdate() {
      return this.$route.params.id !== undefined
    },
  },
  async mounted() {
    if (this.isUpdate) {
      await this.getPeriod({
        routeParameters: {
          id: this.$route.params.id,
        },
      })
      this.form = {
        ...this.period.data,
        names: initMultilingual(this.period.data.names),
      }
    }
  },
  methods: {
    ...mapActions('period', ['savePeriod', 'getPeriod']),
    async submit() {
      await this.savePeriod({
        routeParameters: {
          id: this.$route.params.id,
        },
        ...this.form,
      })
    },
  },
}
</script>
